var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.481 19.3174L15.4292 26.6719L5.49365 14.667L5.71631 9.75488L3.16064 6.66699L5.49365 2.66699L6.0083 3.3291L6.16064 0H9.49365L25.481 19.3174Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61157 14.7533H5.56502V7.45736C5.56502 7.32281 5.56502 7.07726 5.56502 6.7207C5.56502 6.35742 5.56839 5.95714 5.57511 5.51986C5.58857 5.08257 5.60539 4.68902 5.62557 4.33919C5.45066 4.54774 5.28583 4.72602 5.1311 4.87402C4.9831 5.02203 4.83846 5.15994 4.69718 5.28776L3.02205 6.67025L0.953369 4.12728L6.01912 0H9.61157V14.7533Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1Icon);
export default __webpack_public_path__ + "static/media/number_1_icon.cfb509ff718f26a93f7eaaf00fb78569.svg";
export { ForwardRef as ReactComponent };